export default {
  formTitle: 'Password Recovery',
  formText: 'We`ll send a recovery link to your email.',
  backLink: 'Back to Sign In',
};
